import * as Immutable from 'immutable';
import DataUtils from 'common/utils/DataUtils';

class EntityFieldHelper {
    static getNormalizedField({ entity, field, value }) {
        const modifiedField = { ...field };

        // Fallback [] for conditionally rendered fields
        const absoluteAccessor = modifiedField.accessor?.split('.') || [];

        if (!modifiedField.absoluteAccessor) {
            modifiedField.absoluteAccessor = [...absoluteAccessor];
        }

        modifiedField.validators = [];

        while (absoluteAccessor.length > 0) {
            const accessor = absoluteAccessor.pop();
            const probableNestedEntity = entity.getIn(absoluteAccessor);

            // handled case where entity's key -> List (not handling array of entities)
            // in that case the validator of entities in array should be on that level which contains array of entities
            // e.g: entity[x] = [entity1, entity2], validator accessor should be in entity level for entities 1 and 2
            const nestedEntity =
                absoluteAccessor.length > 0 &&
                probableNestedEntity &&
                !Immutable.List.isList(probableNestedEntity)
                    ? probableNestedEntity
                    : entity;

            const validator =
                nestedEntity[nestedEntity.getValidatorName(accessor)];
            if (validator) {
                modifiedField.validators.push(validator.bind(nestedEntity));
            }
        }

        if (modifiedField.getProcessedValueForField) {
            modifiedField.value = modifiedField.getProcessedValueForField({
                field: modifiedField,
                entity,
                value: value !== undefined ? value : field.value
            });
        } else {
            modifiedField.value = entity.getIn(modifiedField.absoluteAccessor);
        }

        return modifiedField;
    }

    static getNormalizedFields({ entity, fields }) {
        const normalizedFields = {};
        for (const accessor in fields) {
            const field = { ...fields[accessor] };
            normalizedFields[accessor] = EntityFieldHelper.getNormalizedField({
                entity,
                field
            });
        }
        return normalizedFields;
    }

    static getValidatedField({ field }) {
        const modifiedField = { ...field };
        // FIXME: modifiedField.required can be function too
        if (
            (modifiedField.required ||
                !DataUtils.isEmpty(modifiedField.value)) &&
            modifiedField.validators
        ) {
            for (const validator of modifiedField.validators) {
                const validationMessage = validator(modifiedField.value);
                if (validationMessage) {
                    modifiedField.validationMessage = validationMessage;
                    return modifiedField;
                }
            }
        }

        if (modifiedField.validationMessage) {
            modifiedField.validationMessage = null;
        }
        return modifiedField;
    }

    static getValidatedFields({ fields }) {
        const validatedFields = {};
        let isValid = true;

        for (const accessor in fields) {
            const field = { ...fields[accessor] };
            const validatedField = EntityFieldHelper.getValidatedField({
                field
            });
            if (validatedField.validationMessage) {
                isValid = false;
            }
            validatedFields[accessor] = validatedField;
        }
        return { isValid, validatedFields };
    }

    static getNormalizedValidatedField({ field, entity, value }) {
        let modifiedField = { ...field };
        modifiedField = EntityFieldHelper.getNormalizedField({
            entity,
            field: modifiedField,
            value
        });
        modifiedField = EntityFieldHelper.getValidatedField({
            field: modifiedField,
            value
        });
        return modifiedField;
    }
}

export default EntityFieldHelper;
